// Stimulus controller for collection filter interactions.
// Intercepts form submission to build clean, SEO-friendly URLs with comma-separated params.
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["filters", "products"]

    connect() {
    }

    // Triggered when any filter checkbox or sort select changes
    filterChange(event) {
        this.#submitFilters()
    }

    // Triggered when mobile sort select changes
    mobileSortChange(event) {
        this.#submitFilters()
    }

    // Triggered when a selected filter chip is clicked to remove it
    removeFilter(event) {
        event.preventDefault()
        const tag = event.currentTarget.dataset.tag
        if (!tag) return

        // Uncheck in both desktop form and mobile offcanvas (prefix m_)
        const desktop = document.getElementById(tag)
        const mobile = document.getElementById(`m_${tag}`)
        if (desktop) desktop.checked = false
        if (mobile) mobile.checked = false

        this.#submitFilters()
    }

    // Builds clean comma-separated URL params and navigates via full page load.
    // Produces: ?tags=celtic,braided&metals=14K&sort=price_asc
    // Instead of: ?tags%5B%5D=113&tags%5B%5D=104&metals%5B%5D=14K&sort_order=best_sellers
    // Uses manual string building (not URLSearchParams) to avoid %2C encoding of commas.
    // Collects from either the desktop form or the mobile offcanvas panel.
    #submitFilters() {
        const form = document.getElementById('collection-render-frm')
        const offcanvas = document.getElementById('filterOffcanvas')
        const isMobile = offcanvas && offcanvas.classList.contains('show')

        // Desktop: scope to the toolbar only (not the full form which also contains
        // the mobile offcanvas with duplicate checkboxes that would stay checked).
        const toolbar = form ? form.querySelector('.collection-toolbar') : null
        const source = isMobile ? offcanvas : toolbar
        if (!source) return

        const parts = []

        const filterGroups = { 'tags[]': 'tags', 'p_tags[]': 'p_tags', 'metals[]': 'metals' }
        for (const [inputName, paramName] of Object.entries(filterGroups)) {
            const checked = source.querySelectorAll(`input[name="${inputName}"]:checked`)
            if (checked.length > 0) {
                const values = Array.from(checked).map(cb => cb.value).join(',')
                parts.push(`${paramName}=${values}`)
            }
        }

        // Sort: mobile uses mobile_sort_order, desktop uses sort_order
        const sortName = isMobile ? 'mobile_sort_order' : 'sort_order'
        const sortSelect = source.querySelector(`select[name="${sortName}"]`)
        if (sortSelect && sortSelect.value && sortSelect.value !== 'best_sellers') {
            const sortMap = { 'best_sellers': 'best', 'price_asc': 'price_asc', 'price_desc': 'price_desc' }
            parts.push(`sort=${sortMap[sortSelect.value] || sortSelect.value}`)
        }

        const baseUrl = window.location.pathname
        window.location = parts.length > 0 ? `${baseUrl}?${parts.join('&')}` : baseUrl
    }
}
